export const NAME_COLUMN_WIDTH = 30;
export const ADDRESS_COLUMN_WIDTH = 20;
export const SHARED_MENU_COLUMN_WIDTH = 20;
export const CITY_COLUMN_WIDTH = 20;
export const SHARED_MENU_NAME_MAX_LENGTH = 50;

export const GOOGLE_SHEETS_PAGE_PATH = 'google-sheets-import';
export const BULK_IMAGE_UPLOAD_PAGE_PATH = 'bulk-image-upload';
export const TRANSLATIONS_PAGE_PATH = 'translations';
